import { render, staticRenderFns } from "./currency-disclaimer.vue?vue&type=template&id=6fae3acb&"
import script from "./currency-disclaimer.vue?vue&type=script&lang=js&"
export * from "./currency-disclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports